import { object, string } from "yup";
import { FormikProps, FormikActions } from "formik";

export const DEFAULT_TEXT = "Type some text here";

export type ValueTypes = {
  folderId: string;
  recordId: string;
  title: string;
  text: string;
};

export type FormTypes = FormikProps<ValueTypes>;

export type FormActionTypes = FormikActions<ValueTypes>;

export const validationSchema = object().shape({
  folderId: string().required("Folder ID is required."),
  recordId: string().required("Record ID is required."),
  title: string().required("Title is required."),
  text: string(),
});
